import React, {Component} from 'react';
import Gdpr from '../gdpr/Gdpr'
import PropTypes from 'prop-types'
import LocaleStorageApp from '../../../js/utils/LocaleStorage'

export default class CookiesBanner extends Component {

  constructor(props) {
    super(props)
    this.state = {
      bannerClosed: false,
      popinOpened: false,
    }
  }

  componentDidMount() {
    // if user has already interacted with the banner
    if (LocaleStorageApp.has("cookies-accept") || LocaleStorageApp.has("gdpr-performance") || LocaleStorageApp.has("gdpr-socials")) {
      // if user has totally or partially accepted cookies
      if (LocaleStorageApp.get("cookies-accept") === true || LocaleStorageApp.get("gdpr-performance") === true || LocaleStorageApp.get("gdpr-socials") === true) {
        this.pushToDataLayer(true)
      } else {
        this.pushToDataLayer(false)
      }
    } else {
      this.pushToDataLayer(false)
    }

    if ( ! LocaleStorageApp.has("cookies-banner-first-load")) {
      LocaleStorageApp.set("cookies-banner-first-load", true)
    }
    else if (LocaleStorageApp.has("cookies-banner-first-load") && LocaleStorageApp.get("cookies-banner-first-load") === true) {
      LocaleStorageApp.set("cookies-banner-first-load", false)
      if ( ! LocaleStorageApp.has("cookies-accept") || LocaleStorageApp.get("cookies-accept") !== true) {
        LocaleStorageApp.set("cookies-banner-dismiss", true)
      }
    }

    if (
      LocaleStorageApp.has("cookies-accept") && LocaleStorageApp.get("cookies-accept") === true ||
      LocaleStorageApp.has("cookies-banner-dismiss") && LocaleStorageApp.get("cookies-banner-dismiss") === true
    ) {
      this.closeBanner()
    }
    this.loadingScripts()
    document.getElementById('gdpr-bottom-link').addEventListener('click', () => this.openPopin('cookiePreference'))
  }

  componentWillUnmount() {
    document.getElementById('gdpr-bottom-link').removeEventListener('click', () => this.openPopin('cookiePreference'))
  }

  closeBanner() {
    this.setState({
      bannerClosed: true
    })
  }

  closePopin() {
    this.setState({popinOpened: false})
  }

  openPopin() {
    this.setState({popinOpened: true})
  }

  loadingScripts() {
    if (LocaleStorageApp.get("gdpr-socials") === true) {
      this.runScripts(this.props.loader.sociales);
      console.log("socials")
    }
    if (LocaleStorageApp.get("gdpr-fonctionality") === true) {
      this.runScripts(this.props.loader.fonctionality);
      console.log("fonctionality")
    }
    if (LocaleStorageApp.get("gdpr-performance") === true) {
      this.runScripts(this.props.loader.performance);
      console.log("performance")
    }
  }

  pushToDataLayer(value) {
    if (window['dataLayer'] && (typeof window['dataLayer'] != 'undefined') && (window['dataLayer'] != null)) {
      window['dataLayer'].push({
        'event': 'changeCookieAccepted',
        'cookieAccepted': value
      });
    }
  }

  runScripts(scripts) {
    for (var i in scripts) {
      eval(scripts[i]);
    }
  }

  acceptCookies() {
    this.closeBanner()
    this.closePopin()
    this.pushToDataLayer(true)

    LocaleStorageApp.set("cookies-accept", true)
    LocaleStorageApp.set("gdpr-fonctionality", true)
    LocaleStorageApp.set("gdpr-performance", true)
    LocaleStorageApp.set("gdpr-socials", true)

    this.loadingScripts()
  }

  onValidClicked(result) {

    this.closePopin()
    this.closeBanner()

    LocaleStorageApp.set("gdpr-performance", result["gdpr-performance"])
    LocaleStorageApp.set("gdpr-socials", result["gdpr-socials"])

    if (result["gdpr-performance"] === true || result["gdpr-socials"] === true) {
      this.pushToDataLayer(true)
    } else if (result["gdpr-performance"] === false && result["gdpr-socials"] === false) {
      this.pushToDataLayer(false)
    }

    this.loadingScripts()
  }

  render() {
    return (
      <div>
        {
          this.state.popinOpened && (
            <Gdpr popin={this.state.popinOpened}
                  gdprPopinTitle={this.props.gdprPopinTitle}
                  gdprCheck1Title={this.props.gdprCheck1Title}
                  gdprCheck1Text={this.props.gdprCheck1Text}
                  gdprCheck2Title={this.props.gdprCheck2Title}
                  gdprCheck2Text={this.props.gdprCheck2Text}
                  gdprValidCta={this.props.gdprValidCta}
                  gdprInfosMore={this.props.gdprInfosMore}
                  handleValidClicked={(result) => this.onValidClicked(result)}
            />
          )
        }
        {
          !this.state.bannerClosed &&
          <div className="cookies-banner">
            <div className="cookies-banner__content">
              <div className="text" dangerouslySetInnerHTML={{__html: this.props.text}}/>
              <div className="buttons-container">
                <div className="button" onClick={() => this.openPopin()}
                     dangerouslySetInnerHTML={{__html: this.props.confidentiallabel}}/>
                <div className="button reverse" onClick={() => this.acceptCookies()}
                     dangerouslySetInnerHTML={{__html: this.props.acceptlabel}}/>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

CookiesBanner.propTypes = {
  confidentiallabel: PropTypes.string,
  acceptlabel: PropTypes.string,
  text: PropTypes.string,
  loader: PropTypes.object,
  gdprPopinTitle: PropTypes.string,
  gdprCheck1Title: PropTypes.string,
  gdprCheck1Text: PropTypes.string,
  gdprCheck2Title: PropTypes.string,
  gdprCheck2Text: PropTypes.string,
  gdprValidCta: PropTypes.string,
  gdprInfosMore: PropTypes.string,
}



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/cookie/CookiesBanner.js